import { Link } from "react-router-dom";
import ProfileImage from "../assets/images/profile_placeholder.png";
import React, { useState, useEffect, useContext } from "react";
import henceforthApi from "../utils/henceforthApi";
import { GlobalContext } from "../context/Provider";
import MaskImage from "../components/common/MaskImage";
import { Button } from "../components/ui/button";

const Profile = () => {
  const { authState } = useContext(GlobalContext);
  return (
    <div className="row animated fadeInRight">
      <div className="text-end">
        <Link to="/profile/edit">
          <Button>
            Edit Profile
          </Button>
        </Link>
      </div>
      <div className="col-md-4 text-black">
        <div className="ibox">
          <div className="ibox-title">
            <h5>Admin Profile Details</h5>
          </div>

          <div className="ibox-content">
            <div className="text-center upload-image h-100 w-100 position-relative">
              <img
                src={
                  authState.image
                    ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${authState.image}`
                    : ProfileImage
                }
                alt="ProfileImage"
                className="large-profile-img"
              />
              <MaskImage profile image={authState?.image} key={authState?.image} />
            </div>
            <div className="mt-4">
              <h4 className="text-black">
                {authState.name.charAt(0).toUpperCase() +
                  authState.name.slice(1)}
              </h4>
              <p className="text-black">
                <i className="fas fa-envelope me-2"></i>
                <span>{authState.email}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;



